<template>
  <button class="button is-info" @click="$emit('click')">
    <span class="icon">
      <i class="fa fa-plus"></i>
    </span>
    <span v-if="label">{{ label }}</span>
    <span v-if="!label">{{ $t('app.buttons.add') }}</span>
  </button>
</template>

<script>
export default {
  name: 'AddButton',
  props: {
    label: String
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/forms/AddButton.vue